<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="640px">
             <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Related Course</v-flex>
                    <v-flex v-else>Update Related Course</v-flex>
                    <v-btn icon @click="CloseCourseModal"> 
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="!Update_Details">
                    <v-flex>
                        <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Course_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Course_Title }}    
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex>
                        <v-select v-model='ChosenRelatedCourse' label='Select Related Courses' :items="GetCourseDetailList" 
                                  item-text="Course_Title" chips clearable multiple return-object>
                                <template v-slot:selection='data'>
                                    <v-chip :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                                        {{ data.item.Course_Title }}
                                    </v-chip>
                                </template>
                                <template v-slot:item='data'>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ data.item.Course_Title }}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                        </v-select>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else>
                    <v-flex>
                        Course : {{ SelectedCourseDetail.Course_Title }}
                    </v-flex>
                    <v-flex>
                        <v-select v-model='ChosenRelatedCourse' label='Select Related Courses' :items="GetCourseDetailList" 
                                  item-text="Course_Title" chips clearable multiple return-object>
                                <template v-slot:selection='data'>
                                    <v-chip :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                                        {{ data.item.Course_Title }}
                                    </v-chip>
                                </template>
                                <template v-slot:item='data'>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ data.item.Course_Title }}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </template>
                        </v-select>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat v-if="!Update_Details" @click="AddRelatedCourse">Add Related Course</v-btn>
                    <v-btn color="primary" flat v-else @click="UpdateRelated">Update Related Course</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
export default {
    props: ['dialog'],
    data(){
        return {

            Update_Details         : false,
            SelectedCourseDetail   : {},
            ChosenRelatedCourse    : [],
        }
    },
    computed:{  
        GetCourseDetailList(){

            return this.$store.getters.GetCourseDetailsList
        },
    },
    methods:{
        CloseCourseModal(){

            this.SelectedCourseDetail  = {}
            this.Update_Details        = false
            this.ChosenRelatedCourse   = []
            this.$emit('close')
        },
        UpdateRelatedCourse(Course){

            this.Update_Details = true
            let Related_Course = Course['Related_Courses'] && Course['Related_Courses'].length > 0 ? Course['Related_Courses'] : [];
            this.SelectedCourseDetail = Course
            Related_Course.forEach(element => {
                let Course = this.GetCourseDetailList.find(x => x['_id'] == element)
                Course && Object.keys(Course).length > 0 ? this.ChosenRelatedCourse.push(Course) : {}
            });
            
        },
        AddRelatedCourse(){

            let data = {}
            data["Course_Id"]       = this.SelectedCourseDetail["_id"]
            data['Related_Courses'] = this.ChosenRelatedCourse.map(x => x['_id'])

            if(this.ChosenRelatedCourse.length > 0 && Object.keys(this.SelectedCourseDetail).length > 0){
    
                this.$http.post(`${this.$store.getters.GetProductionUrl}/course/addrelatedcourse`,data)
                            .then(response =>{
                                
                                this.$store.commit('AddUpdateRelatedCourse',response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Related Course","Color":"green","Close": false });
                                this.CloseCourseModal()
                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Related Course","Color":"red","Close": false });
                            })

            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill All The Details","Color":"red","Close": false });
            }
        },
        UpdateRelated(){

            let data = {}
            data["Course_Id"]       = this.SelectedCourseDetail["_id"]
            data['Related_Courses'] = this.ChosenRelatedCourse.map(x => x['_id'])
            if(this.ChosenRelatedCourse.length > 0 && Object.keys(this.SelectedCourseDetail).length > 0){
    
                this.$http.post(`${this.$store.getters.GetProductionUrl}/course/addrelatedcourse`,data)
                            .then(response =>{
                                
                                this.$store.commit('AddUpdateRelatedCourse',response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Related Course","Color":"green","Close": false });
                                this.CloseCourseModal()
                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating Related Course","Color":"red","Close": false });
                            })

            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill All The Details","Color":"red","Close": false });
            }
        }
    }
}
</script>
<style scoped>

</style>
